import * as Yup from "yup";

export interface DashboardFormGeneralFields {
  name: string;
  dashboard_position?: number;
  is_pinned: boolean;
}

export const DashboardFormGeneralSchema = Yup.object({
  name: Yup.string().required("This field cannot be blank."),
  dashboard_position: Yup.number().optional(),
  is_pinned: Yup.boolean().required(),
});

export const DashboardFormGeneralDefaults = {
  name: "Dashboard",
  dashboard_position: undefined,
  is_pinned: true,
};
